module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: _vm.thisRef,
    staticClass: "file-details",
    attrs: {
      "label-position": "left",
      "inline": ""
    }
  }, [(!_vm.fileData.url) ? _c('div', [_c('h4', [_vm._v("Please upload a file")]), _c('br'), _vm._v(" "), (_vm.fileData.updated_by) ? _c('span', [_vm._v("  \n      "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.deleteFile()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-alt text-danger"
  }, [_vm._v(" ")]), _vm._v("Remove Category\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.fileData.updated_by) ? _c('div', [_vm._v("\n      Updated by: "), _c('b', [_vm._v(_vm._s(_vm.fileData.updated_by))]), _vm._v(" on "), _c('i', [_c('b', [_vm._v(_vm._s(_vm.formatDateTime(this.fileData.updated_at)))])])]) : _vm._e()]) : _c('div', [_c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-form', [_c('el-col', {
    attrs: {
      "span": 21
    }
  }, [_c('text-input', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "label": "Category",
      "disabled": !_vm.editTitle
    },
    model: {
      value: (_vm.fileData.title),
      callback: function($$v) {
        _vm.$set(_vm.fileData, "title", $$v)
      },
      expression: "fileData.title"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [(!this.fileData.approved && this.isManager() && this.isTowerCo()) ? _c('el-button', {
    attrs: {
      "type": "text",
      "plain": "",
      "icon": _vm.editTitle ? 'fa fa-check-circle' : 'fa fa-edit',
      "disabled": _vm.isViewOnly()
    },
    on: {
      "click": _vm.edit
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editTitle) ? _c('el-button', {
    attrs: {
      "type": "text",
      "plain": "",
      "icon": "fa fa-times-circle"
    },
    on: {
      "click": function($event) {
        _vm.editTitle = false
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "File name"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.fileData.name))]), _vm._v(" ("), _c('i', [_vm._v(_vm._s(this.formatInteger(_vm.fileData.size / 1000)) + "k")]), _vm._v(")  \n\n            "), (!_vm.fileData.approved && (!this.fileData.downloaded || this.isManager() || this.isSuper())) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small",
      "plain": "",
      "icon": "fa fa-trash-alt",
      "disabled": _vm.isViewOnly() || _vm.disableForm
    },
    on: {
      "click": _vm.remove
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "align": "middle"
    }
  }, [(!_vm.fileData.approved) ? _c('span', [_vm._v("Approval Status: ")]) : _vm._e(), _vm._v(" "), ((this.isManager() || this.isApprover()) && _vm.showSwitch) ? _c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#E6A23C",
      "disabled": _vm.isViewOnly() || _vm.disableForm
    },
    on: {
      "change": _vm.approved
    },
    model: {
      value: (_vm.fileData.approved),
      callback: function($$v) {
        _vm.$set(_vm.fileData, "approved", $$v)
      },
      expression: "fileData.approved"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fileData.approved) ? _c('b', {
    staticClass: "text-success"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }, [_vm._v(" ")]), _vm._v("Approved")]) : _c('span', {
    staticClass: "text-warning"
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }, [_vm._v(" ")]), _vm._v("Pending")]), _vm._v(" "), (_vm.fileData.approved) ? _c('span', [_c('small', [_vm._v("On "), _c('b', [_vm._v(_vm._s(this.formatDateTime(_vm.fileData.approved_at)))]), _vm._v(" by "), _c('b', [_vm._v(_vm._s(_vm.fileData.approved_by))])])]) : _vm._e()], 1), _vm._v(" "), (_vm.fileData.approved && _vm.formValue.status) ? _c('b', [_vm._v(_vm._s(_vm.formValue.status) + " - ")]) : _vm._e(), _vm._v(" "), (!_vm.editRemarks && _vm.fileData.approved && _vm.fileData.remarks) ? _c('span', [_c('i', {
    staticClass: "text-muted"
  }, [_vm._v("Remarks")])]) : _vm._e(), _vm._v(" "), (_vm.editRemarks) ? _c('html-input', {
    attrs: {
      "disabled": _vm.isViewOnly() || _vm.disableForm
    },
    model: {
      value: (_vm.fileData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.fileData, "remarks", $$v)
      },
      expression: "fileData.remarks"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fileData.approved && (this.isManager() || this.isApprover()) && this.isTowerCo()) ? _c('el-button', {
    attrs: {
      "type": _vm.editRemarks ? 'success' : 'text',
      "plain": "",
      "icon": _vm.editRemarks ? 'fa fa-check-circle' : 'fa fa-edit',
      "disabled": _vm.isViewOnly() || _vm.disableForm
    },
    on: {
      "click": _vm.openRemarks
    }
  }, [_vm._v("\n      " + _vm._s(!_vm.fileData.remarks ? 'Edit Remarks' : '') + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.editRemarks) ? _c('el-button', {
    attrs: {
      "type": _vm.editRemarks ? 'info' : 'text',
      "plain": "",
      "icon": "fa fa-times-circle",
      "disabled": _vm.isViewOnly() || _vm.disableForm
    },
    on: {
      "click": function($event) {
        _vm.editRemarks = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "html-remarks"
  }, [(!_vm.editRemarks && _vm.fileData.approved) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.fileData.remarks)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.isTowerCo() && !_vm.fileData.approved && !_vm.disableForm) ? _c('el-row', [_c('auto-form', {
    attrs: {
      "title": "Additional Info",
      "form": _vm.formDesc,
      "save": _vm.save,
      "override-span": 24,
      "inline": true,
      "label-pos": "left",
      "disabled": _vm.fileData.approved || _vm.isViewOnly() || _vm.disableForm
    },
    model: {
      value: (_vm.formValue),
      callback: function($$v) {
        _vm.formValue = $$v
      },
      expression: "formValue"
    }
  })], 1) : _c('el-row', [(_vm.isTowerCo() && _vm.fileData.depost > 0 || _vm.fileData.ref) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.fileData.deposit) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n           Deposit: "), _c('b', [_vm._v(_vm._s(_vm.formatNumber(_vm.fileData.deposit)))])]) : _vm._e(), _vm._v(" "), (_vm.fileData.ref) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n           Ref: "), _c('b', [_vm._v(_vm._s(_vm.fileData.ref))])]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [(_vm.rowData.mimeType.endsWith('pdf')) ? _c('div', [_c('pdf-viewer', {
    attrs: {
      "url": _vm.getEndpoint('/file/view/' + _vm.fileData.url)
    }
  })], 1) : _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.getEndpoint('/file/view/' + _vm.fileData.url)
    }
  })])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('small', [_vm._v("Uploaded: "), _c('b', [_vm._v(_vm._s(this.fileData.upload_by))]), _vm._v(" at "), _c('b', [_vm._v(_vm._s(this.formatDateTime(this.fileData.upload_at)))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "align": "right"
    }
  }, [(_vm.fileData.downloaded) ? _c('small', [_c('small', [_vm._v("Last Download: On "), _c('b', [_vm._v(_vm._s(this.formatDateTime(_vm.fileData.lastDownload_at)))]), _vm._v(" by "), _c('b', [_vm._v(_vm._s(_vm.fileData.lastDownload_by))])])]) : _vm._e()])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09dbf9f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/details/FileDetails.vue
// module id = 1411
// module chunks = 0